'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Appends the tunnel information to every action which REQUESTED data. The goal of this middleware is to abstract the
 * logging logic for requesting data from the frontend conde
 * @param {StoreType} store The store
 * @param {DispatchType} next Next dispach function
 * @param {ActionType} action The action being dispached
 * @returns {void}
 */
var reduxRequestMiddleware = function reduxRequestMiddleware(store) {
    return function (next) {
        return function (action) {
            var currentState = store.getState();
            var tunnel = currentState.get('tunnel');
            var wrappedAction = action;

            if (action.type.indexOf('_REQUESTED') > -1) {
                wrappedAction = (0, _assign2.default)({}, wrappedAction, {
                    tunnel: tunnel
                });
            }

            next(wrappedAction);
        };
    };
};
exports.default = reduxRequestMiddleware;
//# sourceMappingURL=reduxRequestMiddleware.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-request-middleware/dist/main/reduxRequestMiddleware.js
// module id = 530
// module chunks = 0